import './index.css';
import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import reportWebVitals from './reportWebVitals';
import "./i18nextConf";


ReactDOM.render(
    <React.StrictMode>
      <Suspense fallback="loading">
        <BrowserRouter basename={'/'}>
          <App />
        </BrowserRouter>
      </Suspense>
    </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
